import React, { useState, useRef, useEffect } from 'react';

export default function TagFilterControl({
  availableTags = [],
  tagUsageCount = {},
  selectedTags = [],
  setSelectedTags,
  tagLogic,
  setTagLogic
}) {
  const [tagInput, setTagInput] = useState('');
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef(null);
  const [sortMode, setSortMode] = useState('frequency');

  const addTag = (tag) => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
      setTagInput('');
    }
  };

  const removeTag = (tag) => {
    setSelectedTags(selectedTags.filter(t => t !== tag));
  };

  const clearTags = () => {
    setSelectedTags([]);
    setTagInput('');
  };

    const visibleTags = availableTags
    .filter(tag => tag.toLowerCase().includes(tagInput.toLowerCase()))
    .sort((a, b) => {
        if (sortMode === 'alpha') {
        return a.localeCompare(b);
        }
        return (tagUsageCount[b] || 0) - (tagUsageCount[a] || 0);
    });


  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [visibleTags.length]);

  return (
    <>
      {/* Column 1: Input and logic toggle */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', gridColumn: '1 / 2' }}>
        <input
          type="text"
          placeholder="Search tags"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          className="tag-input"
        />
        <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
          {['AND', 'OR'].map((logic) => (
            <button
              key={logic}
              onClick={() => setTagLogic(logic)}
              className={`tag-toggle ${tagLogic === logic ? 'active' : ''}`}
            >
              {logic}
            </button>
          ))}
          {(selectedTags.length > 0 || tagInput.trim()) && (
            <button
              onClick={clearTags}
              className="tag-toggle"
            >
              Clear
            </button>
          )}
        </div>
        <div style={{ marginTop: '0.3rem', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
  
  <button
    onClick={() => setSortMode('frequency')}
    className={`tag-toggle ${sortMode === 'frequency' ? 'active' : ''}`}
  >
    Frequency
  </button>
  <button
    onClick={() => setSortMode('alpha')}
    className={`tag-toggle ${sortMode === 'alpha' ? 'active' : ''}`}
  >
    A–Z
  </button>
</div>

      </div>
      

      {/* Columns 2–3: Tag pills with conditional fade */}
      <div style={{ position: 'relative', gridColumn: '2 / -1' }}>
  <div
    ref={containerRef}
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '5px',
      alignItems: 'center',
      maxHeight: '4.8em',
      overflowY: 'auto',
      paddingRight: '6px',
      paddingBottom: '0.8em', // lets last row fully scroll into view
      scrollbarGutter: 'stable both-edges'
    }}
  >
    {visibleTags.map((tag, i) => {
      const isSelected = selectedTags.includes(tag);
      return (
        <span
          key={i}
          className={`tag-pill ${isSelected ? 'selected' : ''}`}
          onClick={() => (isSelected ? removeTag(tag) : addTag(tag))}
        >
          {tag}
          {isSelected && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                removeTag(tag);
              }}
              className="tag-pill-close"
            >
              ×
            </button>
          )}
        </span>
      );
    })}
  </div>

  {/* Fading overlay at bottom (non-interactive) */}
  {isOverflowing && (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '1.2em',
        background: 'linear-gradient(to bottom, transparent, var(--bg))',
        pointerEvents: 'none'
      }}
    />
  )}
</div>

    </>
  );
}
